/**
 * Horizon overrides for Boutiqueify.actions:
 * - updatePanier: emit events from the cart drawer scope.
 * - openPanier: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Boutiqueify?.actions;
  if (!actions) return;

  actions.updatePanier.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openPanier.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Boutiqueify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Boutiqueify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
